<script>
  import { onMount } from 'svelte';
  import { slide } from 'svelte/transition'
  import { fly } from 'svelte/transition'
  import { settings } from '../src/data_storage.js'
  settings.useLocalStorage()

  import Azzet from './azzet.svelte'
  import { formatCurrency } from '../src/utils'
  import { _ } from 'svelte-i18n'
  import { Link } from "../rout"

  import { getContext } from 'svelte'

  export let shop
  export let kich
  export let back_handler
  export let add_to_cart_handler
  let azzets

  const { addItem } = getContext('cart')

  function mountFromData(data, pushState = false) {
    console.log('kich_detail onMount')
    console.log(data)
    azzets = kich.azzets
  }

  function loadSettings() {
  }

  function saveSettings() {
  }

  onMount(async () => {
    mountFromData(kich)
    loadSettings()
  })

  function addToCart() {
    addItem(kich, shop)
    if (add_to_cart_handler) {
      add_to_cart_handler(kich)
    }
  }

  function back() {
    if (back_handler) {
      back_handler()
    }
  }
</script>

<div class="meta-buttons mt-1 mb-3 flex flex-row gap-2">
  <Link to="" class="btn" on:click={back}>{$_('back')}</Link>
  <div class="grow flex justify-center self-center font-bold rounded bg-gray-100 dark:bg-black leading-8">{kich.title}</div>
</div>

{#if azzets}
  <div class="flex justify-around grid grid-cols-1 gap-2 md:grid-cols-2 xl:grid-cols-4">
    {#each azzets as azzet}
      <div class="kich m-1">
        <img src={azzet.azzet_url} alt={azzet.title}/>
      </div>
    {/each}
  </div>
{/if}

{#if kich.story}
  <div class="kich flex flex-row justify-center">
    <div class="grow flex justify-center">
      {@html kich.story}
    </div>
  </div>
{/if}

{#if kich.price}
  <div class="kich flex flex-row justify-center">
    <span class="text-gray-500 text-lg">{formatCurrency(kich.price, $settings.locale, $settings.currency, 2, 0)}</span>
  </div>
{/if}

{#if kich.sold}
  <div class="cart-buttons my-3">
    <div class="rounded p-8 bg-red-400 text-white font-bold flex justify-center">
      {kich.kind === 'tangible' ? $_('sold') : $_('reserved')}
    </div>
  </div>
{:else}
  <div class="cart-buttons my-3 flex justify-center">
    <button class="btn" on:click={addToCart}>{$_('btn.add_to_cart')}</button>
  </div>
{/if}
